export default "__VITE_ASSET__f6818f78__"